/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NegotiationInputs */

const en_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const de_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verhandlung`)
};

const fr_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const es_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const it_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const nl_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const pl_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const fi_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const da_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

const sv_nav_negotiation = /** @type {(inputs: Nav_NegotiationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negotiation`)
};

/**
* | output |
* | --- |
* | "Negotiation" |
*
* @param {Nav_NegotiationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_negotiation = /** @type {((inputs?: Nav_NegotiationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NegotiationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_negotiation(inputs)
	if (locale === "fr") return fr_nav_negotiation(inputs)
	if (locale === "es") return es_nav_negotiation(inputs)
	if (locale === "it") return it_nav_negotiation(inputs)
	if (locale === "nl") return nl_nav_negotiation(inputs)
	if (locale === "pl") return pl_nav_negotiation(inputs)
	if (locale === "fi") return fi_nav_negotiation(inputs)
	if (locale === "da") return da_nav_negotiation(inputs)
	if (locale === "sv") return sv_nav_negotiation(inputs)
	return en_nav_negotiation(inputs)
});